import React from "react";
// UI Framework
import { TableCell, TableRow } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
// Common Components
import { DatePicker, Loading, Table, Button } from "src/Components";
// Services
import {
  getCreateAccountsTable,
  createAccount,
} from "src/Requests/imePortfolio";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
import { addComma } from "src/helper";
// Types
import {
  IUserPositionSummarySearchParams,
  CreateAccountsTableReport,
  CreateAccountSearchParams,
} from "src/Interfaces/imePortfolio";

interface IProps {
  searchParams: IUserPositionSummarySearchParams;
  setRefresh: (flag: boolean) => void;
  onClose: () => void;
}

const CreateAccountTable = ({ searchParams, setRefresh, onClose }: IProps) => {
  const [loading, setLoading] = React.useState(false);
  const [baseConfig, setBaseConfig] = React.useState<CreateAccountsTableReport>(
    {} as CreateAccountsTableReport,
  );
  const [searchParam, setSearchParam] = React.useState({
    userId: searchParams.userId,
  } as CreateAccountSearchParams);

  const fetchCreateAccountTable = React.useCallback(() => {
    setLoading(true);
    getCreateAccountsTable(searchParams.userId)
      .then((resp) => {
        setBaseConfig(resp);
        setSearchParam({} as CreateAccountSearchParams);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, [searchParams.userId]);

  React.useEffect(() => {
    setSearchParam((prev) => ({
      ...prev,
      userId: searchParams.userId,
    }));
    fetchCreateAccountTable();
  }, [fetchCreateAccountTable, searchParams.userId]);

  const changeHandler = (name: string, value: any) => {
    setSearchParam((prev) => ({
      ...prev,
      [name]: value,
      userId: searchParams.userId,
    }));
  };

  return (
    <div className="w-80 h-96  px-4 flex flex-col items-center self-center">
      <>
        <DatePicker
          label="تاریخ افتتاح حساب"
          name="date"
          onChange={changeHandler}
          value={searchParam.openDate}
        />
        <div className="w-24 pt-5 mx-auto">
          <Button
            onClick={() => {
              createAccount({
                ...searchParam,
                userId: searchParams.userId,
              }).then(() => {
                fetchCreateAccountTable();
                setRefresh(true);
                onClose();
              });
            }}
            text="ثبت"
            variant="contained"
          />
        </div>
      </>
    </div>
  );
};

export default CreateAccountTable;
